var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.558 30.264L2.892 25.726a1 1 0 01-.843-1.136L5.306 2.58a1 1 0 011.136-.843l30.666 4.538a1 1 0 01.843 1.136l-3.257 22.01a1 1 0 01-1.136.843z",
    stroke: "#7A8595",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.985 10.392l7.695 7.772 9.616-5.21",
    stroke: "#7A8595",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTMzLjU1OCAzMC4yNjRMMi44OTIgMjUuNzI2YTEgMSAwIDAxLS44NDMtMS4xMzZMNS4zMDYgMi41OGExIDEgMCAwMTEuMTM2LS44NDNsMzAuNjY2IDQuNTM4YTEgMSAwIDAxLjg0MyAxLjEzNmwtMy4yNTcgMjIuMDFhMSAxIDAgMDEtMS4xMzYuODQzeiIgc3Ryb2tlPSIjN0E4NTk1IiBzdHJva2Utd2lkdGg9IjIiLz4KICA8cGF0aCBkPSJNMTEuOTg1IDEwLjM5Mmw3LjY5NSA3Ljc3MiA5LjYxNi01LjIxIiBzdHJva2U9IiM3QTg1OTUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgEmptyAttach as ReactComponent };